import { isBranchConstrained } from "../../../auth/sessionAccess.ts";
import React from "react";
import { useAppSettings } from "../../../hooks/useAppSettings.tsx";
import Layout from "../../Layout.tsx";
import { useNavigate, useParams } from "react-router-dom";
import { readBranch } from "../../../services/branch.service.ts";
import Title from "../../Title.tsx";
import { Panel, PanelHeader } from "../../panel/panel.jsx";
import HorarioSucuralFormDate from "./HorarioSucuralFormDate.tsx";
import { useFormik } from "formik";
import Button from "../../Button.tsx";
import {
  generateTimeIntervals,
  getDateByDayOfWeek,
  shifts,
  weekDays,
} from "../../../utils/constanst.js";
import { ScheduleDateSchema } from "../../../validation/schemas/ScheduleDateSchema.ts";
import {
  createHistory,
  readHoursByBranch,
  saveSchedule,
} from "../../../services/branchSchedule.service.ts";
import { notifyBranchSchedulesSaved } from "./config-horario-semanal/scheduleKeyUtils.ts";
import { notification } from "../../../utils/Notifications.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/index.ts";
import ModalContainer from "../../ModalContainer.tsx";
import { Tooltip } from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";

const getStartOfWeek = (date: Date) => {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(date.setDate(diff));
};

const getEndOfWeek = (date: Date) => {
  const startOfWeek = getStartOfWeek(new Date(date));
  return new Date(startOfWeek.setDate(startOfWeek.getDate() + 6));
};

const formatDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const getWeekRange = (date: Date) => {
  const startOfWeek = getStartOfWeek(new Date(date));
  const endOfWeek = getEndOfWeek(new Date(date));
  return `${formatDate(startOfWeek)} a ${formatDate(endOfWeek)}`;
};

const getDayOfWeekFromDate = (date: Date) => {
  const day = date.getDay();
  return day === 0 ? 6 : day - 1;
};

type Props = {};

const SucursalesHorioDate = (props: Props) => {
  useAppSettings();
  const navigate = useNavigate();
  const { refreshScheduleFunction } = useSelector(
    (state: RootState) => state.schedule
  );
  const [firstRender, setFirstRender] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [branch, setBranch] = React.useState<any>(null);
  const [showModal, setShowModal] = React.useState<any>();
  const [selectedDays, setSelectedDays] = React.useState<any>([]);
  const [showHistory, setShowHistory] = React.useState<any>(false);
  const [showCompactView, setShowCompactView] = React.useState(false);

  let id;

  const { user } = useSelector((state: RootState) => state.auth);
  const { id: ipParams } = useParams();

  if (isBranchConstrained(user)) {
    id = user.branchId;
  } else {
    id = ipParams;
  }

  React.useEffect(() => {
    const loadBranch = async () => {
      if (id) {
        const branch = await readBranch(Number(id));
        setBranch(branch);
      }
      setLoading(false);
    };

    loadBranch();
  }, []);

  const today = new Date();
  const initialDayOfWeek = getDayOfWeekFromDate(today);
  const initialDayName = weekDays[initialDayOfWeek]?.name || "";
  const initialWeekRange = getWeekRange(today);

  const formik = useFormik({
    initialValues: {
      branchName: null,
      branchId: Number(id) || -99,
      selectedDate: today.toISOString(),
      shift: 3,
      dayOfWeek: initialDayOfWeek,
      dayName: initialDayName,
      weekRange: initialWeekRange,
      schedule: [
        {
          position: "",
          x: 0,
          w: 0,
          originalId: 0,
          positionId: -99,
          shift: "",
          show: false,
        },
      ],
    },
    validationSchema: ScheduleDateSchema,
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values) => {
      console.log(values.schedule);
      const branchHours = await readHoursByBranch(values.branchId);

      const hoursArray = await generateTimeIntervals(
        branchHours?.matutinoStart,
        branchHours?.vespertinoEnd
      );
      hoursArray.unshift(
        { key: -99, display: "Hora" },
        { key: -99, display: "Hora" }
      );

      try {
        if (selectedDays.length === 0) {
          console.log("values", values);
          const selectedDate = new Date(values.selectedDate);
          const weekRange = getWeekRange(selectedDate);
          const dayOfWeek = getDayOfWeekFromDate(selectedDate);
          const dayName = weekDays[dayOfWeek]?.name || "";

          const object = {
            branchId: values.branchId,
            week: weekRange,
            shift: shifts[values.shift]?.name,
            dayOfWeek: dayName,
            schedule: values.schedule
              .filter((record) => record.show)
              .map((record: any) => ({
                dateRange: weekRange,
                dayOfWeek: dayName,
                positionName: record.position,
                positionX: record.x,
                positionW: record.w,
                positionY: record.y,
                startTime: hoursArray[record.x + 2].display,
                endTime:
                  hoursArray[
                    record.x + record.w + 1 > hoursArray.length
                      ? hoursArray.length + 1
                      : record.x + record.w + 1
                  ]?.display,
                exactDate: moment(selectedDate).format("YYYY-MM-DD"),
                branch: values.branchId,
                partner: record.originalId,
                position: record.positionId,
                shift: record.shift,
                positionOriginalId_: record?.positionOriginalId_,
                originalRecordId: record?.originalRecordId,
              })),
          };

          try {
            await saveSchedule({
              branchId: values.branchId,
              schedule: object.schedule,
              exactDate: moment(selectedDate).format("YYYY-MM-DD"),
              shift: values.shift,
              allowDuplicatePartnerPosition: true,
            });

            notification("Éxito", "Horario guardado correctamente", "success");
          } catch (error) {
            console.error("error", error);
            notification("error", "Error al guardar el horario", "danger");
          }
        } else {
          for (const day of selectedDays) {
            const selectedDate = new Date(values.selectedDate);
            const weekRange = getWeekRange(selectedDate);
            const dayName = weekDays[day]?.name;

            const object = {
              branchId: values.branchId,
              week: weekRange,
              shift: shifts[values.shift]?.name,
              dayOfWeek: dayName,
              schedule: values.schedule
                .filter((record) => record.show)
                .map((record: any) => ({
                  dateRange: weekRange,
                  dayOfWeek: dayName,
                  positionName: record.position,
                  positionX: record.x,
                  positionW: record.w,
                  positionY: record.y,
                  startTime: hoursArray[record.x + 2].display,
                  endTime:
                    hoursArray[
                      record.x + record.w + 1 > hoursArray.length
                        ? hoursArray.length + 1
                        : record.x + record.w + 1
                    ]?.display,
                  exactDate: moment(selectedDate).format("YYYY-MM-DD"),
                  branch: values.branchId,
                  partner: record.originalId,
                  position: record.positionId,
                  shift: record.shift,
                  originalPositionId: record.positionId,
                  positionOriginalId_: record?.positionOriginalId_,
                  ...(values.dayOfWeek === day && {
                    originalRecordId: record?.originalRecordId,
                  }),
                })),
            };

            try {
              await saveSchedule({
                branchId: values.branchId,
                schedule: object.schedule,
                exactDate: moment(selectedDate).format("YYYY-MM-DD"),
                shift: values.shift,
                allowDuplicatePartnerPosition: true,
              });
            } catch (error) {
              console.log("error", error);
              notification("error", "Error al guardar el horario", "danger");
            }
          }

          notification("Éxito", "Horarios guardados correctamente", "success");
          notifyBranchSchedulesSaved(values.branchId, undefined);
          setShowModal(false);
          setSelectedDays([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        await refreshScheduleFunction();
      }
    },
  });

  const handleSave = () => {
    formik.validateForm().then(() => formik.handleSubmit());
  };

  if (showHistory) {
    return (
      <Layout loading={loading}>
        <Title
          baseTitle={`Horario de ${formik.values?.branchName ?? branch?.name}`}
          basePath=""
          title={`Horario de ${formik.values?.branchName ?? branch?.name}`}
        />
        <div className="card border-0 m-4 rounded">
          <Panel>
            <PanelHeader
              extra={
                <Tooltip title="Horario" arrow>
                  <i
                    onClick={() => setShowHistory(false)}
                    style={{ cursor: "pointer" }}
                    className="fa-solid fa-receipt"
                  ></i>
                </Tooltip>
              }
              noButton={true}
              className="bg-azul"
            >
              Historial de horarios
            </PanelHeader>
          </Panel>
          <div className="p-2 d-flex justify-content-end w-100">
            <button
              onClick={() => setShowHistory(false)}
              className="btn btn-secondary"
            >
              Volver
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout loading={loading}>
      <Title
        baseTitle={`Horario de ${formik.values?.branchName ?? branch?.name}`}
        basePath=""
        title={`Horario de ${formik.values?.branchName ?? branch?.name}`}
      />
      <div className="card border-0 m-4 rounded">
        <Panel>
          <PanelHeader noButton={true} className="bg-azul">
            Horario de la sucursal
          </PanelHeader>
          <HorarioSucuralFormDate
            formik={formik}
            firstRender={firstRender}
            setFirstRender={setFirstRender}
            showCompactView={showCompactView}
            setShowCompactView={setShowCompactView}
          />
          {/* Solo mostrar errores cuando NO estamos en vista compacta */}
          {!firstRender &&
            !showCompactView &&
            (formik.errors.branchId ||
              formik.errors.dayOfWeek ||
              formik.errors.schedule ||
              formik.errors.shift ||
              formik.errors.selectedDate) && (
              <div className="alert alert-danger w-50 mx-auto">
                {Object.keys(formik.errors).map((key) => (
                  <div key={key}>{formik.errors[key]}</div>
                ))}
              </div>
            )}
        </Panel>
      </div>
     
      <ModalContainer
        open={showModal}
        title="Horario de la sucursal"
        closeFn={() => setShowModal(false)}
      >
        <div></div>
        <h5 className="mb-3">Se repite el:</h5>
        <div className="d-flex justify-content-around my-3">
          {weekDays.map((day, index) => (
            <button
              key={index}
              type="button"
              onClick={() => {
                const isSelected = selectedDays.includes(index);
                setSelectedDays(
                  isSelected
                    ? selectedDays.filter((dayIndex) => dayIndex !== index)
                    : [...selectedDays, index]
                );
              }}
              className={`btn ${
                selectedDays.includes(index)
                  ? "btn-primary"
                  : "btn-outline-secondary"
              } rounded-pill mx-1`}
              title={day.name}
              style={{
                width: "40px",
                height: "40px",
                textTransform: "capitalize",
              }}
            >
              {day.name.slice(0, 1)}
            </button>
          ))}
        </div>
        <div className="d-flex flex-row mt-5">
          <button
            className="btn btn-secondary ms-auto me-2"
            onClick={() => setShowModal(false)}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={() => formik.submitForm()}
          >
            Guardar
          </button>
        </div>
      </ModalContainer>
    </Layout>
  );
};

export default SucursalesHorioDate;
